import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import {TeamappProvider} from "../../providers/teamapp";
import { Camera, CameraOptions } from '@ionic-native/camera';

/**
 * Generated class for the MarketplaceEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-marketplace-edit',
  templateUrl: 'marketplace-edit.html',
})
export class MarketplaceEditPage {

    maxImages: number = 6;

    id: any;
    title: string = 'Inserieren';
    marketplaceEditForm: FormGroup;
    frontImage: string = '';
    frontEditImage: string = '';
    images: any = [];
    datasets: any;
    base64img: string = '';
    addImages: any = [];
    ptitle: string = '';
    description: string = '';
    price: string = '';
    status: string = '';
    category: string = '';
    location: string = '';

    statusArray: any = [];
    categoryArray: any = [];

    getData: any;
    constructor(private alertCtrl: AlertController, public userProvider: UserProvider, public camera: Camera, private formBuilder: FormBuilder, public navCtrl: NavController, public navParams: NavParams, public teamappProvider: TeamappProvider) {
        if(this.navParams.get("title")) {
            this.title = this.navParams.get("title");
        }
        if(this.navParams.get("id")) {
            this.id = this.navParams.get("id");
        }

        this.teamappProvider.http_request('action=get_item_to_edit&id='+this.id, 'marketplace', false, true).then(data => {
            this.getData = data;

            this.description = this.getData.description;
            this.ptitle = this.getData.title;
            this.images = this.getData.images;
            this.frontImage = this.getData.mainimage;
            this.price = this.getData.price;
            this.status = this.getData.status;
            this.category = this.getData.category_id;
            this.location = this.getData.location;

            this.statusArray = this.getData.status_choose;
            this.categoryArray = this.getData.category_choose;

            console.log(data);
            this.marketplaceEditForm = this.formBuilder.group({
                ptitle: ['', Validators.required],
                description: ['', Validators.required],
                price: ['', Validators.required],
                status: ['', Validators.required],
                category: ['', Validators.required],
                location: [''],
            });
        });

    }

    imageCapturedFront() {
        const options:CameraOptions={
            quality:70,
            destinationType:this.camera.DestinationType.DATA_URL,
            sourceType:this.camera.PictureSourceType.PHOTOLIBRARY,
            saveToPhotoAlbum:false,
            allowEdit: false
        }
        this.camera.getPicture(options).then((ImageData=>{
            this.base64img=ImageData;
            this.frontEditImage = this.base64img;
        }),error=>{
            console.log(error);
        })
    }

    imageCapturedGallery(){
        const options:CameraOptions={
            quality:70,
            destinationType:this.camera.DestinationType.DATA_URL,
            sourceType:this.camera.PictureSourceType.PHOTOLIBRARY,
            saveToPhotoAlbum:false,
            allowEdit: false
        }
        this.camera.getPicture(options).then((ImageData=>{
            this.base64img=ImageData;
            this.addImages.push(this.base64img);
        }),error=>{
            console.log(error);
        })
    }

    deleteImage(id: any) {
        this.teamappProvider.http_request('action=delete_image_items&id='+id, 'marketplace', false, true).then(data => {
            for(let i = 0; i<this.images.length; i++) {
                if(this.images[i].id == id) {
                    this.images.splice(i, 1);
                }
            }
        });
    }

    deleteItem() {
        let alert = this.alertCtrl.create({
            title: 'Löschen bestätigen',
            message: 'Soll das Inserat wirklich gelöscht werden?',
            buttons: [
                {
                    text: 'Abbrechen',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Löschen',
                    handler: () => {
                        this.teamappProvider.http_request('action=delete_item&id='+this.id, 'marketplace', false, true).then(data => {
                            console.log(data);
                            this.navCtrl.pop();
                        });
                    }
                }
            ]
        });
        alert.present();
    }

    deleteAddetImage(image: string) {
        for(let i = 0; i<this.addImages.length; i++) {
            if(this.addImages[i] == image) {
                this.addImages.splice(i, 1);
            }
        }
    }

    editItem() {
        let dIMGString = '';

        for(let i = 0;i<this.addImages.length;i++) {
            dIMGString = dIMGString + '&otherimage['+i+']='+this.addImages[i];
        }

        let frontImageToUrl = '';
        if(this.frontEditImage != '') {
            frontImageToUrl = '&mainimage='+this.frontEditImage;
        }
        this.teamappProvider.http_request('action=edit_item&id='+this.id+dIMGString+frontImageToUrl+'&add_title='+this.ptitle+'&add_description='+this.description+'&add_price='+this.price+'&add_price='+this.price+'&add_status='+this.status+'&add_category='+this.category+'&add_location='+this.location, 'marketplace', false, true).then(data => {
            console.log(data);
            this.navCtrl.pop();
        });


    }

    formatNumber(e: any, separador: string = '.', decimais: number = 2) {
        let a:any = e.value.split('');
        let ns:string = '';
        a.forEach((c:any) => { if (!isNaN(c)) ns = ns + c; });
        ns = parseInt(ns).toString();
        if (ns.length < (decimais+1)) { ns = ('0'.repeat(decimais+1) + ns); ns = ns.slice((decimais+1)*-1); }
        let ans = ns.split('');
        let r = '';
        for (let i=0; i < ans.length; i++) if (i == ans.length - decimais) r = r + separador + ans[i]; else r = r + ans[i];
        e.value = r;
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad MarketplaceAddPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/marketplace-edit/marketplace-edit.ts